// Reading an account's property type for the pricing table.
//
// The customer record stores "Residential" or "Commercial"; the pricing table
// wants "residential" or "commercial". Between the two sit the accounts that
// carry neither - blank, an import leftover, a word nobody uses any more - and
// those are the ones that matter. Treating an unknown type as residential is
// how a commercial property gets quoted at house rates without anyone choosing
// it, so unknown stays unknown here and the dialog says so on screen.

export const PROPERTY_TYPES = ['residential', 'commercial'];

// The account's own type, or null when the record does not say.
export function accountPropertyType(customer) {
  // Only a real string counts. String(['Commercial']) is "Commercial", so a
  // coercion here would read a malformed record as a confident answer.
  const raw = typeof customer?.type === 'string' ? customer.type.trim().toLowerCase() : '';
  return PROPERTY_TYPES.includes(raw) ? raw : null;
}

// What the toggle should show for this account: its type, or residential as the
// visible fallback. Always paired with `accountPropertyType` being null on
// screen, so the fallback is never silent.
export function defaultPropertyType(customer) {
  return accountPropertyType(customer) || 'residential';
}
